import axios from 'axios';

const graphqlApiPath = process.env.REACT_APP_GITLABURL + '/api/graphql';

export const graphqlQuery = async <T>(query: string, variables: any, token?: string) => {
  const data = JSON.stringify({
    query,
    variables,
  });
  const res = await axios.request({
    method: 'POST',
    url: `${graphqlApiPath}?access_token=${token ?? localStorage.getItem('token')}`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (res.data.errors) {
    throw new Error(JSON.stringify(res.data.errors));
  }
  return res.data.data as T;
};
